<template>
    <div id="panel-loader" class="modal">
        <div class="modal-content">
            <img class="loader" src="../assets/loader/dd.png" alt="loader">
        </div>
    </div>
</template>

<script>
    export default {
        name: "PanelLoader"
    }
</script>

<style lang="scss" scoped>
    .modal {
        border-radius: 8px;
        display: flex; /* Hidden by default */
        position: fixed; /* Stay in place */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.2); /* Black w/ opacity */
        z-index: 100000000000;
    }
    .modal-content {
        position: relative;
        background-color:unset!important; ;
        margin: auto;
        padding: 0;
        border: unset!important;
        width: 80%;
        box-shadow:unset!important;
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s;
        z-index: 500000;

    }

#panel-loader{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    right: 0%;
    margin: auto;
    .loader{
        position: absolute;top: 0%;bottom: 0%;margin: auto;left: 0% ;right: 0%
    }
}
.loader {
    /*transform-origin: bottom right;*/
    margin: auto;
    //border: 16px solid #f3f3f3;
    border-radius: 50%;
    //border-top: 16px solid rgb(204, 23, 29);
    width: 170px;
    height: 170px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
}
/* Safari */
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>